module.exports = __webpack_public_path__ + "static/img/308.40c541f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/308.jpg
// module id = a780
// module chunks = 0